module.exports = __webpack_public_path__ + "static/media/END CAP 57.60 X 280 FOR CX.6d432e05.jpg";